import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../EmptyFragment';
import { T } from '../../Translations';
import { MulticheckStore } from '../Store';

interface Props<T> {
  store: MulticheckStore<T>;
  children: React.ReactNode;
}

function MulticheckActions<T>({ store, children }: Props<T>) {
  return fromEmpty(store.selected)
    .map((values) => (
      <div className="flex justify-center fixed bottom-10 inset-x-0 w-[55%] m-auto">
        <div className="flex gap-5 justify-center items-center py-3 px-20 rounded-md bg-white drop-shadow">
          <div className="w-[130px]">
            <T kind="{{count}} item selected" count={values.length} />
          </div>
          {children}
        </div>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(MulticheckActions);
